var map = {
	"./br/PT/S1/gm4.png": 1364,
	"./in/EN/S1/gm4.png": 74367,
	"./ph/EN/S1/gm4.png": 16171,
	"./vn/VI/S1/gm4.png": 73969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15434;